import { useState, useEffect } from "react"

type Props = {
  onChange: (val: string) => void
}

const SearchField = ({
    onChange
}:Props) => {
  const [search, setSearch] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState("")

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
    }, 2000)

    return () => {
      clearTimeout(handler)
    }
  }, [search])

  useEffect(() => {
    onChange(debouncedSearch)
  }, [debouncedSearch])

  return (
    <div className="search-bar">
        <div className="search-bar__icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="6.67" stroke="#C0C0C0" strokeWidth="1.5" />
            <path d="M15.07 15.07L17.5 17.5" stroke="#C0C0C0" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        </div>
        <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="search" className="search-bar__input"/>
    </div>
  )
}

export default SearchField